import { render } from "./FriendInfo.vue?vue&type=template&id=4148c764&scoped=true"
import script from "./FriendInfo.vue?vue&type=script&lang=js"
export * from "./FriendInfo.vue?vue&type=script&lang=js"

import "./FriendInfo.vue?vue&type=style&index=0&id=4148c764&scoped=true&lang=css"

import exportComponent from "/Users/klausdresbach/Dropbox/IT-Projekte/Web-Entwicklung/niceplaces/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4148c764"]])

export default __exports__